/**
 * Returns background, border, and text color values for styling purposes
 * @param {Object} props See Button components for theming API
 * @param {Object} state Should include { isHover, isActive } booleans
 * @returns {Object} The current active background, border, and text colors (depending on state).
 */
export const appearanceForState = (styles, componentState) => {
  const { disabled, isActive, isHover, selected } = componentState;
  // Cascade precedence: Initial < Hover < Active < Focus < Disabled
  return {
    ...styles.initial,
    ...(isHover ? styles.hover : {}),
    ...(isActive || selected ? styles.active : {}),
    ...(disabled ? styles.disabled : {})
  };
};
